__turbopack_context__.v({
  "buttonBlack": "ButtonCommon-module-scss-module__-fBQhW__buttonBlack",
  "buttonWhite": "ButtonCommon-module-scss-module__-fBQhW__buttonWhite",
});
